module.exports = __webpack_public_path__ + "static/img/134_TO8_1828_og.f26eca4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/134_TO8_1828_og.jpg
// module id = /7Tq
// module chunks = 0